export default __webpack_public_path__ + "static/media/phone-call.d3584894.png";